import loadable from '@loadable/component'

export const LazyRegionalsSwgPromoPage = loadable(
    () => import('./RegionalsSwgPromoPage'),
)
